import React from "react";
import * as W from "./WarningStyle";
import GoldenMiniLogo from "../../GoldenMiniLogo/GoldenMiniLogo";

export default function Warning({ onClose }) {
  const handleWhatsAppClick = () => {
    const phone = "5547988192616";

    

    const text =
      "Olá! Quero saber mais sobre a proposta exclusiva para aumentar minha valorização em mais 2% ao mês.";
    window.open(
      `https://wa.me/${phone}?text=${encodeURIComponent(text)}`,
      "_blank"
    );
  };

  return (
    <W.WarningOverlay>
      <W.WarningContainer>
        <W.LogosBox>
          <W.BrandWrapper>
            <GoldenMiniLogo />
          </W.BrandWrapper>
        </W.LogosBox>

        <W.WarningHeader>
          <W.Badge>EXCLUSIVO</W.Badge>
          <W.WarningTitle>
            ATENÇÃO TEMOS ALGO EXCLUSIVO PARA VOCÊ…
          </W.WarningTitle>
        </W.WarningHeader>

        <W.WarningTextContent>
          <p>
            Excelente proposta para você aumentar sua valorização mensal, tendo
            a oportunidade de ter <strong>mais 2% ao mês</strong>.
          </p>
          <p className="footer-text">Chame já seu consultor para aproveitar!</p>
        </W.WarningTextContent>

        <W.ButtonContainer>
          <W.AcceptButton onClick={handleWhatsAppClick}>
            Chamar consultor agora
          </W.AcceptButton>
          <W.CloseButton onClick={onClose}>Fechar</W.CloseButton>
        </W.ButtonContainer>
      </W.WarningContainer>
    </W.WarningOverlay>
  );
}
